<footer class="site-footer-container">
    <div class="container">
       <div class="row">
          <div class="col s12 m7">
             <div class="row">
                <div class="col s12 m4 footer-column">
                   <h2 class="footer-title">Help and Support</h2>
                   <ul class="mdc-custom__footer__links">
                      <li><a href="https://www.miamidade.gov/global/home.page">Miami-Dade Home</a></li>
                      <li><a href="https://www.miamidade.gov/global/disclaimer/privacy-and-security.page">Privacy Statement</a></li>
                      <li><a href="https://www.miamidade.gov/global/disclaimer/ada-notice.page">ADA Notice</a></li>
                      <li><a href="https://www.miamidade.gov/global/disclaimer/disclaimer.page">Disclaimer</a></li>
                      <li><a href="https://www.miamidade.gov/global/disclaimer/about-miami-dade-county.page">About Miami-Dade</a></li>
                   </ul>
                </div>
                <div class="col s12 m4 footer-column">
                   <h2 class="footer-title">Self-Service</h2>
                   <ul class="mdc-custom__footer__links">
                      <li><a href="https://www.miamidade.gov/global/311.page">311 Contact Center</a></li>
                      <li><a href="https://www.miamidade.gov/global/mobile-applications.page">Mobile Applications</a></li>
                      <li><a href="https://gis-mdc.opendata.arcgis.com/">Open Data</a></li>
                      <li><a href="https://www.miamidade.gov/global/publicrecords/search.page">Public Records</a></li>
                      <li><a href="https://www.miamidade.gov/global/navigation/service-index.page">Service Directory</a></li>
                   </ul>
                </div>
                <div class="col s12 m4 footer-column">
                   <h2 class="footer-title">Stay Connected</h2>
                   <ul class="mdc-custom__footer__links">
                      <li><a href="https://www.miamidade.gov/global/rss-news.page">News RSS Feed</a></li>
                      <li><a href="https://www.miamidade.gov/global/navigation/legal-ad-index.page">Legal Ads &amp; Public Notices</a></li>
                      <li><a href="https://www.miamidade.gov/global/social-media.page">Social Media Directory</a></li>
                   </ul>
                </div>
             </div>
          </div>
          <div class="col s12 m4 offset-m1">
             <div class="right-align">
                <p><a href="https://www.miamidade.gov/global/home.page"><img src="https://www.miamidade.gov/resources/images/md-logo.png" class="md-logo-footer" alt="Miami-Dade County Home"></a></p>
                <p>© <span id="footer-current-year">2022</span> Miami-Dade County. All rights reserved.</p>
                <p><a aria-label="Center for Digital Government - Government Experience Awards 2019 Winners Announced" href="" alt="Center for Digital Government - Government Experience Awards 2019 Winners Announced" target="_blank"><img class="gov-awards-overall-winner" alt="" src="https://www.miamidade.gov/resources/global/images/govawards-overall-winner.jpg"></a></p>
             </div>
          </div>
       </div>
    </div>
    <div class="back-to-top top-active"><a href="#">
          <div class="fa fa-arrow-up fa-2x"></div><span class="sr-only">Back to top</span></a></div>
  </footer>
  <div class="floating-bar" aria-label="Floating container holding global assets for miamidade.gov">
    <div class="container">
       <div class="floating-bar__table">
          <div class="floating-bar__left-container floating-bar__table-column">
             <div class="floating-bar__left-container__table">
                <div class="floating-bar__left-container__table-column">
                  <a href="https://www.miamidade.gov/global/home.page">
                    <img alt="Miami-Dade County Homepage" src="https://www.miamidade.gov/resources/global/images/beta-miamidade-gov.png">
                  </a>
                </div>
                <div class="floating-bar__left-container__table-column">
                  <a href="https://www.facebook.com/miami.dade.county" target="_blank" class="social-media-circle social-media-circle--facebook">
                      <div class="fa fa-facebook-square"></div><span class="sr-only">Miami-Dade County Facebook - Opens a warning dialog</span></a>
                      <a href="https://www.twitter.com/MiamiDadeCounty" target="_blank" class="social-media-circle social-media-circle--twitter">
                      <div class="floating-bar__x-icon">
                       <img src="https://www.miamidade.gov/resources/Icons/brands/twitter-x-logo-white.svg" alt="X icon"></div><span class="sr-only">Miami-Dade County Twitter - Opens a warning dialog</span></a><a href="https://www.instagram.com/miamidadecounty/" class="social-media-circle social-media-circle--instagram">
                      <div class="fa fa-instagram"></div><span class="sr-only">Miami-Dade County Instagram - Opens a warning dialog</span></a>
                      <a href="https://www.youtube.com/user/MiamiDadeTV" target="_blank" class="social-media-circle social-media-circle--youtube">
                      <div class="fa fa-youtube-play" aria-hidden="true"></div><span class="sr-only">Miami-Dade County TV  - Opens a warning dialog</span></a></div>
             </div>
          </div>
          <div class="floating-bar__right-container floating-bar__table-column right-align">
           <a id="feedback" href="https://miamidadecounty.co1.qualtrics.com/jfe/form/SV_ehUyWHof5ekicZL" 
           target="_blank" aria-label="Feedback"><span>Feedback</span><div class="material-icons">chat</div></a></div>
       </div>
    </div>
  </div>
 
  
  
